import { c as _c } from "react/compiler-runtime";
export default function ClockIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M16 3c7.168 0 13 5.832 13 13s-5.832 13-13 13S3 23.168 3 16c0-2.448.677-4.802 1.94-6.84-.419.126-.86.274-1.353.449a1 1 0 0 1-.666-1.887c1.337-.471 2.586-.876 4.348-1.053l.022-.001.01-.001-.032.002a1.008 1.008 0 0 1 .198 0l.036.006a.997.997 0 0 1 .835.745l.007.032c.375 1.727.377 3.04.341 4.458a1.001 1.001 0 0 1-1 .975h-.024a1 1 0 0 1-.976-1.025c.016-.637.02-1.189-.001-1.712A10.934 10.934 0 0 0 5 16c0 6.065 4.935 11 11 11s11-4.935 11-11S22.065 5 16 5c-1.558 0-3.063.319-4.475.948a.998.998 0 0 1-1.32-.506.998.998 0 0 1 .506-1.32A12.906 12.906 0 0 1 16 3zm0 5.002a1 1 0 0 1 1 1v6.634l2.977 3.548a1 1 0 1 1-1.532 1.285l-3.21-3.827a.976.976 0 0 1-.235-.605V9.002a1 1 0 0 1 1-1z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}